import {store} from "../store";
import {keyboardWizardSlice} from "./keyboardWizardSlice";
import {KeyboardWizardPage} from "./keyboardWizardTypes";

export const keyboardWizardStore = {
  // State modifiers
  reset: () => {
    store.dispatch(keyboardWizardSlice.actions.resetReducer());
  },
  setActiveDevice: ({activeDeviceId, activeDeviceName}: {activeDeviceId: string | undefined, activeDeviceName: string | undefined}) => {
    store.dispatch(keyboardWizardSlice.actions.activeDeviceReducer({activeDeviceId, activeDeviceName}));
  },
  setCanShowInputDetectedFromWrongDeviceModal: (canShow: boolean) => {
    store.dispatch(keyboardWizardSlice.actions.canShowInputDetectedFromWrongDeviceModalReducer({canShow}));
  },
  setCurrentPage: (currentPage: KeyboardWizardPage) => { store.dispatch(keyboardWizardSlice.actions.currentPageReducer({currentPage})); },
  setDeviceToConfigureId: (deviceToConfigureId: string | undefined) => {
    store.dispatch(keyboardWizardSlice.actions.deviceToConfigureIdReducer({deviceToConfigureId}));
  },
  setDeviceToConfigureName: (deviceToConfigureName: string | undefined) => {
    store.dispatch(keyboardWizardSlice.actions.deviceToConfigureNameReducer({deviceToConfigureName}));
  },
  setHighestNote: (note: number) => {
    store.dispatch(keyboardWizardSlice.actions.highestNoteReducer({note}));
  },
  setIsOpen: (isOpen: boolean) => {
    store.dispatch(keyboardWizardSlice.actions.isOpenReducer({isOpen}));
  },
  setLowestNote: (note: number) => {
    store.dispatch(keyboardWizardSlice.actions.lowestNoteReducer({note}));
  },
  setShowInputDetectedFromWrongDeviceModal: (show: boolean) => {
    store.dispatch(keyboardWizardSlice.actions.showInputDetectedFromWrongDeviceModalReducer({show}));
  },

  // Getters
  getActiveDeviceId: () => keyboardWizardSlice.selectors.activeDeviceIdSelector(store.getState()),
  getActiveDeviceName: () => keyboardWizardSlice.selectors.activeDeviceNameSelector(store.getState()),
  getCanShowInputDetectedFromWrongDeviceModal: () => keyboardWizardSlice.selectors.canShowInputDetectedFromWrongDeviceModalSelector(store.getState()),
  getCurrentPage: () => keyboardWizardSlice.selectors.currentPageSelector(store.getState()),
  getDeviceToConfigureId: () => keyboardWizardSlice.selectors.deviceToConfigureIdSelector(store.getState()),
  getDeviceToConfigureName: () => keyboardWizardSlice.selectors.deviceToConfigureNameSelector(store.getState()),
  getHighestNote: () => keyboardWizardSlice.selectors.highestNoteSelector(store.getState()),
  getIsOpen: () => keyboardWizardSlice.selectors.isOpenSelector(store.getState()),
  getLowestNote: () => keyboardWizardSlice.selectors.lowestNoteSelector(store.getState()),
  getShowInputDetectedFromWrongDeviceModal: () => keyboardWizardSlice.selectors.showInputDetectedFromWrongDeviceModalSelector(store.getState()),
};
